import React from "react";

export const SvgCopyLink = (props) => {
	return (
		<svg
			width="31"
			height="16"
			viewBox="0 0 31 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M3.20217 7.74122C3.20217 5.19674 5.27047 3.12844 7.81495 3.12844H13.767V0.30127H7.81502C3.70814 0.30127 0.375 3.63434 0.375 7.74122C0.375 11.8481 3.70814 15.1812 7.81502 15.1812H13.767V12.3541H7.81502C5.27054 12.3541 3.20217 10.2857 3.20217 7.74122Z"
				fill="#2368a2"
			/>
			<path
				d="M21.2067 6.25928H9.30273V9.2353H21.2067V6.25928Z"
				fill="#2368a2"
			/>
			<path
				d="M22.6942 0.30127H16.7422V3.12844H22.6942C25.2386 3.12844 27.3069 5.19674 27.3069 7.74122C27.3069 10.2857 25.2386 12.3541 22.6942 12.3541H16.7422V15.1812H22.6942C26.801 15.1812 30.1342 11.8481 30.1342 7.74122C30.1342 3.63434 26.801 0.30127 22.6942 0.30127Z"
				fill="#2368a2"
			/>
		</svg>
	);
};
